import { render, staticRenderFns } from "./AddressColumn.vue?vue&type=template&id=1b5edccf"
import script from "./AddressColumn.vue?vue&type=script&lang=js"
export * from "./AddressColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports